var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogoutMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 0.666748C6.62699 0.666748 0.666992 6.62675 0.666992 14.0001C0.666992 21.3734 6.62699 27.3334 14.0003 27.3334C21.3737 27.3334 27.3337 21.3734 27.3337 14.0001C27.3337 6.62675 21.3737 0.666748 14.0003 0.666748ZM14.0003 24.6667C8.12033 24.6667 3.33366 19.8801 3.33366 14.0001C3.33366 8.12008 8.12033 3.33341 14.0003 3.33341C19.8803 3.33341 24.667 8.12008 24.667 14.0001C24.667 19.8801 19.8803 24.6667 14.0003 24.6667ZM18.787 7.33341L14.0003 12.1201L9.21366 7.33341L7.33366 9.21341L12.1203 14.0001L7.33366 18.7867L9.21366 20.6667L14.0003 15.8801L18.787 20.6667L20.667 18.7867L15.8803 14.0001L20.667 9.21341L18.787 7.33341Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogoutMenu);
export default __webpack_public_path__ + "static/media/icon_logout_menu.6b93822d8107d014df5fcb3aa324b910.svg";
export { ForwardRef as ReactComponent };